module.exports = __webpack_public_path__ + "media/images/fill-10@2x-cea8906bfc4013e17932502a06d8795f.png";